// Opções compartilhadas de destaque e vaga afirmativa (cadastro + exibição).
export const HIGHLIGHT_OPTIONS = [
  { value: 'nova', label: 'Vaga Nova', cls: 'bg-emerald-500 text-white' },
  { value: 'urgente', label: 'Vaga Urgente', cls: 'bg-red-500 text-white' },
  { value: 'exclusiva', label: 'Vaga Exclusiva', cls: 'bg-hm-orange text-white' },
];

export const AFFIRMATIVE_OPTIONS = [
  'Público Feminino',
  'Pessoas Negras',
  'PCD',
  'LGBTQIAPN+',
  '50+',
  'Pessoas Indígenas',
  'Refugiados',
];
